import React, { Component } from "react";
import { CanvasJSChart } from "canvasjs-react-charts";
import { withReportsList } from "../../../../shared/containers/containerReportsList";
import { withTimerangeIntelligence } from "../../../../shared/containers/containerTimerangeIntelligence";
import { withChartSensors } from "../../../../shared/containers/containerChartSensors";
import { withMapPositions } from "../../../../shared/containers/containerMapPositions";

import { withCurrentDevices } from "../../../../shared/containers/containerCurrentDevice";

import { states } from "../../../../reducers/queriesStates";
import Preloader from "../../../../shared/items/static/preloader";
import { getChartOptions } from "./chartDataService";
import "./chart.css";

class SensorsChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: props.data !== undefined,
      dataValues: props.data === undefined ? null : props.data,
      carId: props.unitId,
    };
  }

  componentDidMount() {
    const { reportsListDataState, onGetReportsList } = this.props;

    if (reportsListDataState !== states.READY) {
      onGetReportsList();
    }
  }

  componentDidUpdate(prevProps) {
    const { reportsListDataState, chartSensorsDataState, chartSensorsData } = this.props;

    if (prevProps.reportsListDataState === states.REQUEST && reportsListDataState === states.READY) {
      this.getChartData();
    }

    if (prevProps.chartSensorsDataState === states.REQUEST && chartSensorsDataState === states.READY) {
      this.setState({ dataValues: chartSensorsData, isLoaded: true });
    }

    if (prevProps.chartSensorsDataState !== states.REQUEST && chartSensorsDataState === states.REQUEST) {
      this.setState({ dataValues: null, isLoaded: false });
    }
  }

  getChartData = () => {
    const { onGetChartSensors, reportsListData, startDate, endDate } = this.props;
    const { carId } = this.state;

    const chartReport = reportsListData.filter((item) => {
      return item.buildType === 2;
    })[0];

    onGetChartSensors(
      {
        carId,
        startDate,
        endDate,
      },
      chartReport
    );
  };

  render() {
    const { dataValues, isLoaded } = this.state;

    if (!isLoaded) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Preloader />
        </div>
      );
    }

    const options = getChartOptions(dataValues, 200);

    if (options.data.length === 0) {
      return <div>Данных нет</div>;
    }

    return (
      <div className="chartContainer">
        <CanvasJSChart options={options} />
      </div>
    );
  }
}

export default withCurrentDevices(withMapPositions(withTimerangeIntelligence(withChartSensors(withReportsList(SensorsChart)))));
